import { View } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import BaseTeamPage from './BaseTeamPage';
import { TeamExtendedProfile } from 'src/replicant/team/team.schema';
import { TeamEntry } from './TeamEntry';
import { AsyncScroll } from 'src/game/components/shared/AsyncScroll';
import StateObserver from 'src/StateObserver';
import { Feature } from 'src/replicant/analytics';

export default class TeamTeamsPage extends BaseTeamPage {
  private scroll!: AsyncScroll<
    TeamExtendedProfile | { message: string },
    TeamEntry
  >;

  constructor(private superview: View) {
    super(superview);
    this.addContent();
    this.addHeader();
  }

  private addHeader() {
    const width = this.header.style.width * 0.85;
    const padding = (this.header.style.width - width) * 0.5;
    new LangBitmapFontTextView({
      superview: this.header,
      font: 'Body',
      size: 36,
      color: '#F24463',
      localeText: () => i18n('match2.team.teams_header_message'),
      width,
      height: this.header.style.height - 5,
      x: padding,
      align: 'center',
      verticalAlign: 'center',
    });
  }

  private addContent() {
    this.scroll = new AsyncScroll({
      superview: this,
      rect: {
        x: 0,
        y: this.header.style.height,
        width: this.superview.style.width,
        height: this.superview.style.height - this.header.style.height,
      },
      createItem: (superview, _, data) => {
        const entry = new TeamEntry({ superview });
        entry.on('Close', () => {
          this.emit('Close');
        });
        if ('loading' in data) {
          data = { message: i18n('match2.team.loading') };
        }
        entry.style.x = (superview.style.width - entry.style.width) * 0.5;
        entry.setup(data);
        return entry;
      },
      recycle: true,
      setData: (_, data, view) => {
        if ('loading' in data) {
          data = { message: i18n('match2.team.loading') };
        }
        view.setup(data);
      },
    });

    this.scroll.setDataProvider(
      async () => {
        const members =
          await StateObserver.replicant.asyncGetters.getRecommendedTeams();

        if (!members.length) {
          return [{ message: i18n('match2.team.no_results') }];
        }
        return members;
      },
      {
        feature: Feature.TEAM._,
        subFeature: Feature.TEAM.RECOMMENDED_TEAMS,
      },
    );
  }
}
